export const YegoDashboardContract  = {
    async efficiencyYBI(client_id, period, year, month, shipping_service) {
        client_id;
        period; 
        year; 
        month; 
        shipping_service;

        throw new Error("efficiencyYBI not implemented");
    },

    async efficiencyYBIFinishied(client_id, period, year, month, shipping_service) {
        client_id;
        period; 
        year; 
        month; 
        shipping_service;

        throw new Error("efficiencyYBIFinishied not implemented");
    },

    async buyoutYBI(client_id, period, year, month, shipping_service) {
        client_id;
        period; 
        year; 
        month; 
        shipping_service;

        throw new Error("buyoutYBI not implemented");
    },

    async summaryTransitYBI(year, month, client_id, shipping_service) {
        year; 
        month; 
        client_id;
        shipping_service;

        throw new Error("summaryTransitYBI not implemented");
    },

    async transitYBI(year, month, client_id, shipping_service) {
        year; 
        month; 
        client_id;
        shipping_service;

        throw new Error("transitYBI not implemented");
    },
}